import moment from "moment";

// returns age in years (age) and months (month) and days (day)
export const calculateAge = (dob: string): { age: string; month: string; day: string } => {
    const today = moment(new Date());
    const dobInMoment = moment(dob);
    const years = today.diff(dobInMoment, 'year');
    dobInMoment.add(years, 'years');
    const months = today.diff(dobInMoment, 'months');
    dobInMoment.add(months, 'months');
    const days = today.diff(dobInMoment, 'days');

    return { age: years.toString(), month: months.toString(), day: days.toString() };
};

export const getAgeString = (
    a: { age?: string; month?: string; dob?: string },
    prefix?: string,
    suffix?: string,
): string => {
    let aa, am, ad;

    if (a.dob) {
        const temp = calculateAge(a.dob);
        aa = temp.age;
        am = temp.month;
        ad = temp.day;
    } else {
        aa = a.age;
        am = a.month;
    }

    const ageInt = parseInt(aa || '0');
    const ageMonthInt = parseInt(am || '0');
    const ageDayInt = parseInt(ad || '0');

    if (isNaN(ageInt) && isNaN(ageMonthInt)) {
        return '';
    }

    if (aa && am && ageInt > 0 && ageMonthInt > 0) {
        return `${prefix || ''}${ageInt}${'y'}, ${ageMonthInt}${'m'}${suffix || ''}`;
    } else if (aa && ageInt > 0) {
        return `${prefix || ''}${ageInt}${'y'}${suffix || ''}`;
    } else if (am && ageMonthInt > 0) {
        if (ageMonthInt > 11) {
            return getAgeString(
                { age: `${ageMonthInt / 12}`, month: `${ageMonthInt % 12}` },
                prefix,
                suffix,
            );
        }
        return `${prefix || ''}${ageMonthInt}${'m'} ${ad && ageDayInt > 0 ? `, ${ad}${'d'}` : ''}${
            suffix || ''
        }`;
    } else if (ad && ageDayInt > 0) {
        return `${prefix || ''}${ad}${'d'}${suffix || ''}`;
    }

    return '';
};
